import { ComponentProps, FC, ReactNode, useCallback, useEffect, useState } from 'react'
import { ReadOnlyField } from 'components/features/creditCard/creditCardOnboarding/ReadOnlyField/ReadOnlyField'
import { InPlaceInput } from 'components/features/creditCard/creditCardOnboarding/InPlaceInput/InPlaceInput'
import resolveErrorById from 'constants/errors'
import styles from 'components/features/creditCard/creditCardOnboarding/EditInPlace/EditInPlace.styl'
import { QAMarked } from 'interfaces/component'

type EditInPlaceProps = QAMarked & {
  label: ReactNode
  value: string
  className?: string
  isLoading?: boolean
  error?: string | null
  mask?: (string | RegExp)[]
  maskValue?: (value: string) => string
  validationSchema?: ComponentProps<typeof InPlaceInput>['validationSchema']
  maxLength?: number
  onChange: (value: string) => void
  submitOnBlur?: boolean
}
export const EditInPlace: FC<EditInPlaceProps> = (props) => {
  const { label, value, className, isLoading, onChange, mask, maskValue, error, qaMarker, validationSchema, maxLength, submitOnBlur } = props
  const [isEdit, setEdit] = useState(false)

  const [localError, setLocalError] = useState(error || null)
  useEffect(() => setLocalError(error || null), [error])

  const handleEdit = useCallback(() => {
    setEdit(true)
  }, [])

  const handleSave = useCallback((nextValue: string) => {
    if (localError) {
      setLocalError(null)
    }
    onChange(nextValue)
    setEdit(false)
  }, [localError, onChange])

  const handleCancel = useCallback(() => {
    setEdit(false)
  }, [])

  return (
    <div className={ className }>
      { !isEdit && (
        <>
          <ReadOnlyField
            label={ label }
            values={ [value] }
            isLoading={ isLoading }
            onEdit={ handleEdit }
            maskValue={ maskValue }
            qaMarker={ qaMarker }
          />
          { localError && (
            <div className={ styles.error }>
              { resolveErrorById(localError as any) }
            </div>
          )}
        </>
      )}
      { isEdit && (
        <InPlaceInput
          label={ label }
          value={ value }
          onSave={ handleSave }
          onCancel={ handleCancel }
          mask={ mask }
          qaMarker={ qaMarker }
          validationSchema={ validationSchema }
          maxLength={ maxLength }
          submitOnBlur={ submitOnBlur }
        />
      )}
    </div>
  )
}
